var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.CheckImgUrl())?_c('img',{style:({
    cursor: 'pointer',
    border: '1px solid black',
    borderRadius: '10px',
    width: _vm.width,
    height: _vm.height,
  }),attrs:{"src":_vm.imgUrl,"alt":""}}):_c('div',{staticClass:"userImage",style:({
    background: _vm.bgcolor,
    color: _vm.ftColor,
    width: _vm.width,
    border: '1px solid black',
    borderRadius: '10px',
    height: _vm.height,
    lineHeight: _vm.height,
    marginTop: _vm.MarginTop,
  })},[_vm._v("\n    "+_vm._s(_vm.username.substr(_vm.username.length - 1))+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }